import axios from "../../../_snowpack/pkg/axios.js";
import "../../../_snowpack/pkg/bootstrap/dist/css/bootstrap.css";
import React, {useEffect, useState} from "../../../_snowpack/pkg/react.js";
import {Dropdown} from "../../../_snowpack/pkg/react-bootstrap.js";
import ListGroup from "../../../_snowpack/pkg/react-bootstrap/ListGroup.js";
import styles from "./SpotifyPlaylist.module.css";
const SpotifyPlaylist = (props) => {
  const [token, setToken] = useState(null);
  const [playlist, setPlaylist] = useState(null);
  const playlists = ["78uqePzXN2gdzipWen1Wvs", "0eyGzfSROdxpUhLsqG8SS1", "00f7yGiGTv5gf6tg2IQIFt", "1KnpgSdlIK5ufNMwyIZ1S2", "6r9HtOOE5uxAH9KPY9BXwh", "1k4mQehns5eEkKsamvqmqY"];
  const [dropDownGenre, setDropDownGenre] = useState("Choose Playlist");
  useEffect(() => {
    setToken(props.token);
  }, [props.token]);
  const selectPlaylist = (given_index) => {
    const newPlayList = playlists[given_index];
    getPlaylist(newPlayList);
    updateGenre(given_index);
  };
  const updateGenre = (given_index) => {
    switch (given_index) {
      case 0:
        setDropDownGenre("Rock");
        return;
      case 1:
        setDropDownGenre("EDM");
        return;
      case 2:
        setDropDownGenre("Throwbacks");
        return;
      case 3:
        setDropDownGenre("Chill");
        return;
      case 4:
        setDropDownGenre("Hip-hop");
        return;
      case 5:
        setDropDownGenre("Current Obessions");
        return;
      default:
        setDropDownGenre("Choose Playlist");
        return;
    }
  };
  const getPlaylist = async (playlist_id_param) => {
    axios.get("https://api.spotify.com/v1/playlists/" + playlist_id_param + "/tracks", {
      headers: {
        Authorization: "Bearer " + token
      }
    }).then((response) => {
      setPlaylist(response.data);
    }).catch((error) => {
      console.log(error);
    });
  };
  const renderTrackNames = () => {
    if (playlist != null) {
      return playlist.items.map((item, index) => /* @__PURE__ */ React.createElement(ListGroup.Item, {
        className: styles.trackContainer,
        key: index,
        onClick: () => props.handler(item.track.uri)
      }, /* @__PURE__ */ React.createElement("img", {
        src: item.track.album.images.url,
        alt: "NOT FOUND",
        className: styles.listAlbum
      }), /* @__PURE__ */ React.createElement("p", {
        className: styles.list
      }, item.track.name, " - ", item.track.artists[0].name)));
    }
    return null;
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: styles.spotifyPlaylistContainer
  }, /* @__PURE__ */ React.createElement(Dropdown, {
    style: {display: "sticky"}
  }, /* @__PURE__ */ React.createElement(Dropdown.Toggle, {
    variant: "secondary",
    className: styles.genreDropdown
  }, dropDownGenre), /* @__PURE__ */ React.createElement(Dropdown.Menu, {
    className: styles.dropdownContainer
  }, /* @__PURE__ */ React.createElement(Dropdown.Item, {
    className: styles.dropdownText,
    onClick: () => selectPlaylist(0)
  }, "Rock"), /* @__PURE__ */ React.createElement(Dropdown.Item, {
    className: styles.dropdownText,
    onClick: () => selectPlaylist(1)
  }, "EDM"), /* @__PURE__ */ React.createElement(Dropdown.Item, {
    className: styles.dropdownText,
    onClick: () => selectPlaylist(2)
  }, "Throwbacks"), /* @__PURE__ */ React.createElement(Dropdown.Item, {
    className: styles.dropdownText,
    onClick: () => selectPlaylist(3)
  }, "Chill"), /* @__PURE__ */ React.createElement(Dropdown.Item, {
    className: styles.dropdownText,
    onClick: () => selectPlaylist(4)
  }, "Hip-hop"), /* @__PURE__ */ React.createElement(Dropdown.Item, {
    className: styles.dropdownText,
    onClick: () => selectPlaylist(5)
  }, "Current Obsessions"))), /* @__PURE__ */ React.createElement(ListGroup, null, renderTrackNames()));
};
export default SpotifyPlaylist;
